import { ExternalLink, Check } from "lucide-react";

const HIGHLIGHTS = [
    "Informações sobre tratamentos endodônticos",
    "Apresentação da microscopia operatória",
    "Comunicação da proposta de atendimento individualizado",
    "Acesso aos canais de contato e agendamento",
];

export const Portfolio = () => {
    return (
        <section
            id="portfolio"
            data-testid="portfolio-section"
            className="py-24 border-b border-[#1e2430] bg-[#0c1017]"
        >
            <div className="max-w-6xl mx-auto px-6">
                <div className="mb-14">
                    <span className="code-font text-xs text-[#2563eb] uppercase tracking-wider block mb-2">
                        02 / Portfólio Selecionado
                    </span>
                    <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-white mb-3">
                        Projetos selecionados.
                    </h2>
                    <p className="text-slate-400 max-w-xl text-sm leading-relaxed">
                        Conheça alguns dos projetos desenvolvidos pela Linkora e veja como
                        transformamos ideias em experiências digitais.
                    </p>
                </div>

                <div className="grid md:grid-cols-2 gap-8 items-start">
                    <article
                        data-testid="project-card-endoriccio"
                        className="p-6 rounded-2xl bg-[#111724] border border-[#222e42] hover:border-blue-500/50 transition-colors flex flex-col justify-between"
                    >
                        <div>
                            <div className="rounded-xl overflow-hidden relative mb-6 border border-slate-800">
                                <img
                                    src="/images/endoriccio-home.jpg"
                                    alt="Captura da página inicial do site endoriccio.com"
                                    className="w-full aspect-[16/9] object-cover object-top"
                                    loading="lazy"
                                />
                                <div className="absolute top-4 left-4 code-font text-[10px] bg-black/70 text-blue-300 px-2.5 py-1 rounded border border-blue-500/30">
                                    PROJETO AO VIVO
                                </div>
                            </div>

                            <span className="code-font text-[11px] text-blue-400 uppercase tracking-wider block mb-1">
                                Site Profissional | Saúde e Odontologia
                            </span>
                            <h3 className="text-xl font-bold text-white mb-3">
                                Dr. Gabriel Riccio — Endodontista
                            </h3>
                            <p className="text-xs text-slate-300 leading-relaxed mb-4">
                                Site profissional que apresenta o trabalho do Dr. Gabriel Riccio,
                                especialista em Endodontia. Reúne informações sobre tratamentos
                                endodônticos, uso da microscopia operatória, atendimento
                                individualizado e canais de contato para pacientes interessados em
                                esclarecer dúvidas ou agendar consultas.
                            </p>
                            <ul className="space-y-1.5 mb-6">
                                {HIGHLIGHTS.map((item) => (
                                    <li
                                        key={item}
                                        className="flex items-start gap-2 text-[11px] text-slate-400"
                                    >
                                        <Check className="w-3.5 h-3.5 text-blue-400 mt-0.5 shrink-0" />
                                        {item}
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <div className="pt-4 border-t border-slate-800/80 flex items-center justify-between">
                            <span className="code-font text-xs text-slate-400">endoriccio.com</span>
                            <a
                                href="https://endoriccio.com/"
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="project-visit-site"
                                className="px-4 py-2 bg-blue-600 hover:bg-blue-500 text-white rounded-lg text-xs font-semibold flex items-center gap-1.5 transition-colors"
                            >
                                Visitar site
                                <ExternalLink className="w-3.5 h-3.5" />
                            </a>
                        </div>
                    </article>

                    <div
                        data-testid="portfolio-next-project"
                        className="p-8 rounded-2xl bg-[#0f1420] border border-dashed border-[#222e42] flex flex-col justify-between h-full"
                    >
                        <div>
                            <div
                                className="h-44 rounded-xl overflow-hidden relative mb-6 ambient-drift"
                                style={{
                                    background:
                                        "radial-gradient(circle at 40% 40%, #1e293b, #090d16)",
                                }}
                            >
                                <div className="absolute inset-0 flex items-center justify-center p-6 text-center">
                                    <div className="space-y-2">
                                        <span className="code-font text-xs text-blue-400 uppercase tracking-widest block">
                                            [ Próximo Projeto ]
                                        </span>
                                        <p className="text-xs text-slate-400 max-w-xs">
                                            Espaço reservado para o próximo trabalho real da
                                            Linkora.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <h4 className="text-lg font-bold text-white mb-2">
                                Seu projeto pode ser o próximo aqui.
                            </h4>
                            <p className="text-xs text-slate-400 leading-relaxed">
                                Desenvolvemos sites sob medida para clínicas, empresas e
                                profissionais que desejam fortalecer sua presença digital.
                            </p>
                        </div>

                        <div className="pt-6">
                            <a
                                href="#orcamento"
                                data-testid="portfolio-cta-start-project"
                                className="w-full py-3 bg-[#131a26] hover:bg-[#1b2536] border border-[#2b3952] text-blue-300 text-xs font-semibold rounded-lg flex items-center justify-center gap-2 transition-colors"
                            >
                                Iniciar meu projeto agora &rarr;
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
